'use client'

import { Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { Dispatch, FC, SetStateAction } from 'react'
import { tss } from 'tss-react/mui'
import Button from '../Button/Button'
import ButtonLink from '../Button/ButtonLink'
import { ExpandLessIcon, ExpandMoreIcon } from '../Icon/catalog'
import { CollapsibleProps } from './Collapsible'

const useStyles = tss.withNestedSelectors<'isSimple'>().create(({ theme, classes }) => ({
    isSimple: {},
    root: {
        marginTop: theme.spacing(3),
        textAlign: 'center',

        [`&.${classes.isSimple}`]: {
            marginTop: 0,
        },
    },
    stack: {
        alignContent: 'center',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
    },
}))

const ActionButton: FC<{
    actionText: CollapsibleProps['actionText']
    isExpanded: boolean
    setExpanded: Dispatch<SetStateAction<boolean>>
    withEndIcon?: boolean
    isSimple?: boolean
}> = ({ actionText, isExpanded, setExpanded, withEndIcon, isSimple }) => {
    const { classes, cx } = useStyles()
    const onClick = () => setExpanded(!isExpanded)

    if (isSimple) {
        return (
            <ButtonLink onClick={onClick} className={cx(classes.root, classes.isSimple)}>
                <Stack direction="row" className={classes.stack}>
                    {`${actionText} ${isExpanded ? 'less' : 'more'}`}
                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Stack>
            </ButtonLink>
        )
    }

    return (
        <>
            <Divider />
            <Box className={classes.root}>
                <Button
                    variant="text"
                    endIcon={withEndIcon ? isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon /> : undefined}
                    onClick={onClick}
                >
                    {`${actionText} ${isExpanded ? 'less' : 'more'}`}
                </Button>
            </Box>
        </>
    )
}

export default ActionButton
